import { JSX, useEffect, useRef, useState } from "react";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { TooltipPlacement } from "@app/shared/literals";

interface EllipsisTooltipProps {
  position?: TooltipPlacement;
  width?: string;
  text: string;
  maxLength?: number;
  /**
   * Defaults to true. Set false when this sits inside an already-focusable ancestor (e.g. a
   * button) so the tooltip trigger does not add a second keyboard tab stop.
   */
  focusable?: boolean;
}

const EllipsisTooltip = (props: EllipsisTooltipProps): JSX.Element => {
  const ref: React.RefObject<HTMLDivElement> = useRef(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  const isManuallyTruncated: boolean = props.maxLength !== undefined && props.text.length > props.maxLength;
  const displayText: string = isManuallyTruncated ? `${props.text.substring(0, props.maxLength)}...` : props.text;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setIsEllipsisActive(!isManuallyTruncated && el.offsetWidth < el.scrollWidth);
  }, [props.text]);

  return (
    <TooltipWrapper
      containerClassName="d-block ellipsis-tooltip"
      position={props.position ?? "bottom"}
      suppressTriggerTabIndex={props.focusable === false}
      text={isManuallyTruncated || isEllipsisActive ? props.text : ""}
      triggerWidth="100%"
    >
      <div className="ellipsis" style={{ width: props.width }} ref={ref}>
        {displayText}
      </div>
    </TooltipWrapper>
  );
}

export { EllipsisTooltip };
